import React from "react";
import MadeInLancasterHeader from "./MadeInLancasterHeader";
interface Props {
  categoryId: number;
  heading: string;
  subHeading?: string;
  image: string;
}
const PhotoGridHeader = (props: Props): JSX.Element => {
  const {
    categoryId,
    heading,
    subHeading,
    image
  } = props;
  const madeInLancasterCategoryId = 55085;
  return categoryId === madeInLancasterCategoryId ? <MadeInLancasterHeader {...props} data-sentry-element="MadeInLancasterHeader" data-sentry-component="PhotoGridHeader" data-sentry-source-file="PhotoGridHeader.tsx" /> : <div className="container hero hero--sm hero--text-md hero--category" data-sentry-component="PhotoGridHeader" data-sentry-source-file="PhotoGridHeader.tsx">
      <div className="hero-container container">
        <h1 className="hero-text hero-text--medium hero-text--left">
          {heading}
        </h1>
        {subHeading && <h2 className="hero-text hero-text--xsmall hero-text--left">
            {subHeading}
          </h2>}
      </div>
      <picture data-sentry-element="picture" data-sentry-source-file="PhotoGridHeader.tsx">
        <source srcSet="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" media="(max-width: 599px)" />
        <div className="hidden h-0 m-0 overflow-hidden relative xs:block" style={{
        paddingBottom: "27%"
      }}>
          <img className="pointer-events-none absolute inset-0 w-full" src={image} alt="" />
        </div>
      </picture>
    </div>;
};
export default PhotoGridHeader;